module.exports = __webpack_public_path__ + "img/deep-1.73acca49.jpg";